import { Controller } from "@hotwired/stimulus"
import { post } from "@lib/requests"
import { showAlert } from "@lib/utils"

// Connects to data-controller="product-item-form"
export default class extends Controller {
  
  static targets = ["wrapper", "input"]
  static values = {
    productId: String
  }

  toggleRenewable(e) {
    if (e.target.checked) {
      this.wrapperTarget.classList.remove("hidden")
      this.inputTarget.focus()
    } else {
      this.wrapperTarget.classList.add("hidden")
    }
  }

  changeDosageSearch(e) {
    const form = e.target.closest("form")
    const button = form.querySelector("button")
    const formData = new FormData(form)
    const dosageId = formData.get("dosage-search")
    button.disabled = !dosageId
  }

  async setDosage(dosageId) {
    if (!this.hasProductIdValue || !dosageId) return
    const response = await post(`/api/v1/dosages/${dosageId}/associate`, { body: { product_id: this.productIdValue } })
    const json = await response.json
    if (response.ok) {
      const dosageTextField = this.element.querySelector("textarea[name='product_item[dosage]']")
      const updatedDosageField = this.element.querySelector("input[name='update_dosage']")
      dosageTextField.value = json.dosage.text
      updatedDosageField.checked = true
      const details = this.element.querySelector("details")
      details.open = false
      const dosageWrapper = this.element.querySelector("#dosage-wrapper")
      dosageWrapper.classList.add("hidden")
      showAlert("Posologie associée avec succès", { type: "success" })
    } else {
      showAlert("Erreur lors de l'association de la posologie", { type: "error" })
    }
  }
  
  associateDosage(e) {
    e.preventDefault()
    this.setDosage(e.target.dataset.dosageId)
  }

  async submitDosageSearch(e) {
    e.preventDefault()
    const form = e.target
    const select = form.querySelector("select")
    const formData = new FormData(form)
    const dosageId = formData.get("dosage-search")
    if (!dosageId) return
    await this.setDosage(dosageId)
    select.value = ""
  }
  
}
